export default {
    layout: {
        loading: 'עסקה מתבצעת',
        trading: 'עסקה מתבצעת'
    },
    footer: {
    },
    menu: {
        home: 'דף הבית',
        staking: 'מטריצה',
        port: 'PORT',
        internet: 'רשת',
        me: 'שלי'
    },
    header: {
        selectLang: 'בחר שפה',
        close: 'סגור',
        trading: 'מסחר',
        dashboard: 'לוח בקרה',
        subscribeMatrix: 'הרשמה למטריצה',
        portTaskCenter: 'מרכז משימות PORT',
        network: 'רשת',
        apiBinding: 'קישור API',
        gridTree: 'עץ רשת',
        account: 'חשבון',
        documents: 'מסמכים ו־Whitepaper',
        personalCenter: 'מרכז אישי',
        language: 'שפה'
    },
    home: {
        recently1:'קהילה',
        staticrewares: 'סטטי',
        recentlyName: 'ספר חשבונות',
        recentlyInfo: 'פרטי הכנסות',
        dataUpdate: 'עדכון נתונים',
        realtime: 'זמן אמת · BSC',
        totalRevenue: 'סה״כ הכנסות (USDT)',
        today: 'היום',
        totalTradingVolume: 'סה״כ נפח מסחר',
        todayEarn: 'רווח היום',
        share: 'שתף עם חברים',
        shareDesc: 'הצג רווחים, הזמן וקבל תגמול',
        directReferrals: 'הפניות ישירות',
        teamMembers: 'חברי צוות',
        thisWeek: 'השבוע',
        copy: 'העתק',
        recently: 'רווחים אחרונים',
        netIncome: 'הכנסה נטו',
        dailyAverage: 'ממוצע יומי',
        quantitativeIncome: 'הכנסה כמותית',
        recommend: 'המלץ',
        port: 'PORT',
        bonus: 'בונוס',
        all: 'הכל',
        todayTitle: 'היום',
        loadingMore: 'טען עוד',
        recommendBonus: 'בונוס הפניה',
        portTaskPassed: 'משימת PORT הושלמה',
        myProfit: 'הרווח שלי',
        earningOnBitDeep: 'אני מרוויח ב־BitDeep',
        totalRevenueUsdt: 'סה״כ הכנסות · USDT',
        consecutiveDays: 'ימים רצופים',
        scanToJoin: 'סרוק כדי להצטרף',
        uid: 'UID',
        referralBonus: 'בונוס הפניה',
        shareTo: 'שתף אל',
        eachReferral: 'תגמול שיתוף',
        screenshotAndShare: 'צלם מסך ושתף',
        saveShareEarn: 'שמור · שתף · הרווח',
        period: 'תקופה',
        netProfit: 'רווח נטו',
        quantReward: 'תגמול כמותי',
        dailyBonus: 'בונוס יומי PORT',
        close: 'סגור',
        permission: 'הרשאה',
        onlyEnable: 'הפעל בלבד',
        enterBitgetUid: 'הזן BITGET UID',
        slogan: 'סיסמה',
        document: 'מסמך',
        days: 'ימים',
        taskText: 'משימה',
        minutes: 'דקות',
        decentralizedPortTech: 'ארכיטקטורת PoRT מבוזרת, כלכלת אסימון BGB ומטריצת תמריצים כפולה.',
        auditReport: 'דוח ביקורת',
        faqSupport: 'שאלות נפוצות ותמיכה',
        telegram: 'Telegram',
        piece: 'חלק',
        faq: 'שאלות נפוצות',
        faq1: 'איך מקשרים את Bitget API?',
        faq1Desc: 'עברו אל בורסת Bitget → הגדרות → ניהול API לקבלת API Key ו-Secret. הפעילו אך ורק הרשאת מסחר Spot; אסור בהחלט להפעיל הרשאת משיכה. הדביקו את המפתחות ב-BitDeep DApp. לאחר ביצוע עסקת בדיקה של 1 USDT, הקישור מופעל.',
        faq2: 'מה זה PoRT (הוכחת מסחר אמיתי)?',
        faq2Desc: 'PoRT הוא המנגנון המרכזי של "מסחר = כרייה". מדי יום, המערכת מבצעת אוטומטית באמצעות Bitget API קניות-מכירות מהירות על מטבע מסוים (למשל BGB). כאשר נפח המסחר חוצה את Stake × 50%, המערכת מאמתת ומפעילה את התגמול היומי.',
        faq3: 'האם צריך לעקוב ידנית מדי יום?',
        faq3Desc: 'לא. לאחר קישור ה-API, המערכת משלימה אוטומטית את משימת המסחר בחלון של 24 שעות. אין צורך בפעולה ידנית; ניתן לבדוק את ההתקדמות בתפריט PoRT.',
        faq4: 'מה ההבדל בין ALPHA ל-SIGMA?',
        faq4Desc: 'ALPHA (מתחילים): סטייקינג 500 USDT, תשואה יומית 0.3–1.3%, מוגבל לחבילה אחת. SIGMA (פרו): סטייקינג 1,000 USDT, תשואה יומית 0.6–1.6%, עד 5 חבילות.',
        faq5: 'האם הכספים שלי בטוחים? האם הפלטפורמה יכולה לגעת בכספי?',
        faq5Desc: 'הכספים שלך נשארים ב-100% בחשבון ה-Bitget שלך. ה-API מעניק רק הרשאות קריאה ומסחר Spot; המערכת אינה יכולה למשוך או להעביר קרן כלשהי.',
        faq6: 'מתי הרווחים היומיים מסולקים?',
        faq6Desc: 'לאחר שאימות PoRT עובר, הסילוק מתבצע למחרת. המערכת משחררת אוטומטית פרס כפול — רווחי USDT ונקודות 10x Deep.',
        faq7: 'כיצד מחושב פרס הסקאוט (פרס הפניה ישירה)?',
        faq7Desc: 'עבור כל חשבון פעיל שהזמנת ישירות, אתה מקבל פרס יומי קבוע: 1 USDT/יום עבור הפניית ALPHA (500 USDT), 2 USDT/יום עבור הפניית SIGMA (1,000 USDT). התשלום נמשך עד שמסתיים מחזור החשבון.',
        faq8: 'כיצד מעלים רמה (D1–D7)?',
        faq8Desc: 'עליית רמה לפי נפח כולל של האזור המשני. למשל: D1 דורש 2,000 USDT, D3 דורש 15,000 USDT, D7 (הגבוה ביותר) דורש 3,000,000 USDT. ככל שהרמה גבוהה יותר, פרס פערי הרמות גדול יותר (עד 7 USDT/אדם/יום ב-D7).',
        faq9: 'כמה ימים נמשך מחזור אחד? מה קורה בסיומו?',
        faq9Desc: 'מחזור אחד נמשך 28 ימים. בסיום המחזור ניתן לבחור להמשיך בסטייקינג; הפרסים משולמים לפי תוצאות אימות ה-PoRT היומיות בפועל (תשואה משתנה).',
        faq10: 'האם יש עמלות על משיכה?',
        faq10Desc:'המשיכות הן ללא עמלה. הפלטפורמה מחזירה את עמלות המשיכה לבריכה כדי לחזק את נזילות ה-LP, ויוצרת מחזור חיובי.',
        bigArea: 'אזור גדול',
        smallArea: 'אזור קטן',
        enterWithdrawAmount: 'הזן סכום משיכה',
        all: 'הכל',
        available: 'זמין',
        totalAmount: 'סכום כולל',
        confirmWithdraw: 'אשר משיכה',
        withdrawRecord: 'רישום משיכות',
        withdrawn: 'נמשך',
        quickStartGuide:'מדריך התחלה מהירה',
        whitepaperGuide:'Whitepaper ומדריך',
         whitepaper:'Whitepaper ',
        downloadPdf:'הורד'
    },
    staking: {
        selectPackage: 'הרשמה למטריצה',
        alpha: 'ALPHA',
        beginner: 'מתחיל',
        sigma: 'SIGMA',
        professional: 'מקצועי',
        popular: 'הכי פופולרי',
        dailyReturn: 'תשואה יומית',
        teamDepth: 'עומק צוות',
        limitPurchase: 'מגבלת רכישה',
        layer: 'שכבה',
        copy: 'חלק',
        autoRenew: 'חידוש אוטומטי',
        autoReinvest: 'השקעה חוזרת אוטומטית',
        subscribeAlpha: 'הרשמה ל־Alpha',
        subscribeSigma: 'הרשמה ל־Sigma',
        stakedAmount: 'סכום Stake',
        stakedAmount2: 'תקופה',
        stakedAmount3: 'סה״כ הכנסות',
        stakingTime: 'זמן Stake',
        maturityTime: 'זמן סיום',
        redeem: 'פדיון',
        renew: 'חידוש',
        autoRenewActive: 'חידוש אוטומטי פעיל',
        autoRenewInactive: 'חידוש אוטומטי לא פעיל',
        smartContract: 'ניהול חוזה חכם, הכספים נעולים ל־28 יום ונפתחים בסיום.'
    },
    me: {
        account: 'חשבון',
        my: 'שלי',
        staked: 'Stake בוצע',
        points: 'נקודות',
        consecutive: 'ימים רצופים',
        withdraw: 'משיכה',
        language: 'שפה',
        simplifiedChinese: 'סינית פשוטה',
        disconnectWallet: 'נתק ארנק',
        level: 'רמה',
        joinDate: 'תאריך הצטרפות',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'קישור API',
        bindDesc: 'קשר את מפתחות ה־API של הבורסה כדי לאפשר מסחר כמותי',
        apiKey: 'מפתח API',
        apiSecret: 'סוד API',
        exchange: 'בורסה',
        futures: 'חוזים עתידיים',
        spot: 'ספוט',
        readOnly: 'קריאה בלבד',
        bind: 'קשר',
        riskNote: 'מפתחות API משמשים רק לסנכרון נתוני מסחר, מידע רגיש לא נשמר',
        apiConnection: 'חיבור API',
        bindExchangeApi: 'קשר API של הבורסה',
        bitDeepRead: 'BitDeep קורא זרימת הזמנות מחשבון CEX שלך כדי לאמת הוכחת מסחר אמיתי (PoRT).',
        noWithdraw: 'לעולם לא ניגע במשיכות שלך.',
        securityTip: 'טיפ אבטחה · קרא בעיון',
        close: 'סגור',
        withdraw: 'משיכה',
        permission: 'הרשאה',
        onlyEnable: 'הפעל בלבד',
        spotTrading: 'מסחר ספוט',
        read: 'קריאה',
        recommendedPartner: 'שותף מומלץ',
        zeroFee: '0% עמלה',
        activated: 'מופעל',
        classicAccount: 'חשבון קלאסי',
        unifiedAccount: 'חשבון מאוחד',
        bindBitgetApi: 'קשר Bitget API',
        upcoming: 'בקרוב',
        underAudit: 'בבדיקה',
        expected: 'צפוי'
    },
    port: {
    portTaskCenter: 'מרכז משימות PORT',
    dailyTask: 'משימה יומית',
    verify: 'אמת',
    completed: 'הושלם',
    incomplete: 'לא הושלם',
    verifyStandard: 'תקן אימות',
    tradingVolume: 'נפח מסחר',
    today: 'היום',
    deadline: 'מועד אחרון',
    reward: 'תגמול',
    startVerify: 'התחל אימות',
    verifying: 'מאמת',
    verified: 'אומת',
    insufficient: 'לא מספיק',
    viewDetails: 'צפה בפרטים',
    taskList: 'רשימת משימות',
    allTasks: 'כל המשימות',
    completedTasks: 'הושלם',
    pendingTasks: 'בהמתנה',
    proofOfRealTrading: 'הוכחת מסחר אמיתי',
    todayTask: 'משימת היום',
    todayStaticIncome: 'הכנסה סטטית היום',
    points: 'נקודות',
    todayWindowClosesAt: 'חלון היום נסגר ב־',
    checkTaskStatus: 'בדוק מצב משימה',
    teamProgress: 'התקדמות צוות · היום',
    realtimePortCompletion: 'השלמת PORT בזמן אמת',
    completedText: 'הושלם',
    pendingText: 'בהמתנה',
    realtimeApiValidationFlow: 'זמן אמת · API · זרימת אימות',
    rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
},
internet: {
    network: 'רשת',
    treeBrowser: 'דפדפן עץ',
    searchAddress: 'חפש כתובת 0x... או BD-ID',
    totalTradingVolume: 'סה״כ נפח מסחר',
    members: 'חברים',
    networkStructure: 'מבנה רשת',
    allLevels: 'כל הרמות',
    addRemark: 'הוסף הערה',
    enterRemark: 'אנא הזן הערה',
    cancel: 'ביטול',
    confirm: 'אישור'
},
withdraw: {
    withdraw: 'משיכה',
    usdtAsset: 'נכס USDT',
    withdrawAmount: 'סכום משיכה',
    availableBalance: 'יתרה זמינה',
    fee: 'עמלה',
    actualArrival: 'הגעה בפועל',
    submit: 'שלח',
    withdrawSuccess: 'משיכה הצליחה',
    withdrawFailed: 'משיכה נכשלה',
    processing: 'בעיבוד',
    completed: 'הושלם',
    withdrawHistory: 'היסטוריית משיכות'
},
popup: {
    taskUnfinished: 'משימה לא הושלמה',
    taskUnfinishedDesc: 'נתוני המסחר לא עמדו בתקני PoRT היום',
    todayTradingVolume: 'נפח מסחר היום',
    remaining: 'נותר',
    toComplete: 'להשלמת משימת היום',
    tradingVolumeThreshold: '',
    deadline: 'נותר עד סיום המשימה',
    tryAgain: 'נסה שוב מאוחר יותר',
    goTrade: 'לך למסחר',
    taskCompleted: 'משימה אומתה',
    taskCompletedDesc: 'הוכחת המסחר PoRT היום נרשמה בהצלחה בבלוקצ׳יין',
    rewardIssued: 'תגמול הונפק',
    complete: 'הושלם',
    shareTitle: 'הזמנה לשיתוף',
    shareDesc: 'הזמן חברים להירשם, שני הצדדים יקבלו תגמול',
    referralLink: 'קישור הזמנה',
    qrCode: 'קוד QR',
    copyLink: 'העתק קישור'
}
}
